// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TailwindMerge from "tailwind-merge";
import * as StimulusTabContext$LiteracyplanetTupperware from "../v2/StimulusTabContext.res.mjs";
import * as StimulusToggleContext$LiteracyplanetTupperware from "../v2/StimulusToggleContext.res.mjs";

function PilotStimulusContainer$Modal(props) {
  var tabs = props.tabs;
  var match = Curry._1(StimulusTabContext$LiteracyplanetTupperware.use, undefined);
  var onChangeTab = match.onChangeTab;
  var isTabContentShowing = match.isTabContentShowing;
  var match$1 = Curry._1(StimulusToggleContext$LiteracyplanetTupperware.useState, undefined);
  var onToggleStimulus = match$1[1];
  return React.createElement("div", {
              className: TailwindMerge.twMerge(match$1[0] ? "pilot-stimulus-container-background" : "hidden"),
              onClick: (function (param) {
                  Curry._1(onToggleStimulus, undefined);
                })
            }, React.createElement("div", {
                  className: "pilot-stimulus-container"
                }, tabs.length > 1 ? React.createElement("div", {
                        className: "pilot-stimulus-tabs"
                      }, Belt_Array.map(tabs, (function (tab) {
                              return React.createElement("button", {
                                          key: tab,
                                          className: TailwindMerge.twMerge(Curry._1(isTabContentShowing, tab) ? "pilot-stimulus-tab-button-selected" : "", "pilot-stimulus-tab-button"),
                                          onClick: (function (evt) {
                                              Curry._1(onChangeTab, tab);
                                              evt.stopPropagation();
                                            })
                                        }, tab);
                            }))) : null, props.children));
}

var Modal = {
  make: PilotStimulusContainer$Modal
};

function PilotStimulusContainer(props) {
  var tabs = props.tabs;
  return React.createElement(StimulusToggleContext$LiteracyplanetTupperware.make, {
              show: true,
              children: React.createElement(StimulusTabContext$LiteracyplanetTupperware.make, {
                    tabs: tabs,
                    children: React.createElement(PilotStimulusContainer$Modal, {
                          tabs: tabs,
                          children: props.children
                        })
                  })
            });
}

var make = PilotStimulusContainer;

var $$default = PilotStimulusContainer;

export {
  Modal ,
  make ,
  $$default as default,
}
/* react Not a pure module */
